var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27183_169597)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18.5C4.03738 18.5 0 14.4626 0 9.5C0 4.53738 4.03738 0.5 9 0.5C13.9626 0.5 18 4.53738 18 9.5C18 14.4626 13.9626 18.5 9 18.5ZM13.6673 12.6616C13.7782 12.6616 13.8685 12.5714 13.8685 12.4604V6.81016L9.28944 10.4464C9.20471 10.5138 9.1023 10.5474 8.99996 10.5474C8.89762 10.5474 8.79525 10.5137 8.71049 10.4464L4.13142 6.81016V12.4604C4.13142 12.5714 4.22174 12.6616 4.33269 12.6616H13.6673ZM12.9656 6.33836L9 9.48748L5.03441 6.33836H12.9656ZM14.7996 6.53963V12.4604C14.7996 13.0848 14.2916 13.5927 13.6673 13.5927H4.33269C3.70832 13.5927 3.20041 13.0848 3.20041 12.4604V6.53963C3.20041 5.91529 3.70835 5.40736 4.33269 5.40736H13.6673C14.2916 5.40732 14.7996 5.91529 14.7996 6.53963Z",
    fill: "#E95F56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27183_169597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5e14cc4a6821fd328149b3f407c7c8ab.svg";
export { ForwardRef as ReactComponent };